import ReportPage from "../../components/ReportPage";
import { downloadDistributionSummary } from "../../API";

const schema = {
  title: "Stock Level Summary",
  params: [
    { name: "banners", label: "Banners", type: "multiselect", route: "banners", fields: ["name"], payloadKey: "bannerIds", required: true },
    { name: "products", label: "Products", type: "multiselect", route: "products", cascadesFrom: "manufacturer", fields: ["description", "formatQut", "format"], payloadKey: "productIds", required: true,
      dependsOnValues: ["banners"],
      buildQueryFn: (manufacturer, commonParams, values) => {
        const p = new URLSearchParams();
        p.set("manufacturerId", manufacturer.id);
        (commonParams.provinces ?? []).forEach((pr) => p.append("provinceIds", pr.id));
        ((values ?? {}).banners ?? []).forEach((b) => p.append("bannerIds", b.id));
        return `/for-report-selector?${p.toString()}`;
      } },
  ],
  downloadFn: downloadDistributionSummary,
};

export default function DistributionSummaryReport() {
  return <ReportPage schema={schema} />;
}
